import { APIConfiguration, axiosBionextTV } from 'api';
import { BaseService } from './base.service';
import { Video } from 'models/video.model';

class VideosService extends BaseService {
  async getVideos(lang: string) {
    const { data } = await axiosBionextTV.get<{ videos: Video[] }>(`${this.apiConfig.VIDEOS.GET}`);

    this.log(`getVideos()`);

    return data.videos;
  }
}

export default (apiConfig: APIConfiguration) => {
  return new VideosService(apiConfig);
};
